import { render, staticRenderFns } from "./TCLAProductLinks.vue?vue&type=template&id=1ebf72e3&scoped=true"
import script from "./TCLAProductLinks.vue?vue&type=script&lang=js"
export * from "./TCLAProductLinks.vue?vue&type=script&lang=js"
import style0 from "./TCLAProductLinks.vue?vue&type=style&index=0&id=1ebf72e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf72e3",
  null
  
)

export default component.exports